import axios from '../utils/axios';

export default function fetchShowcaseV2Plan(adminId, params) {
    return (
        axios.get(`/admin/${adminId}/showcase-v2-plans`,{ params })
    )
}
